import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'contractors-liability',
  templateUrl: './contractors-liability.component.html',
  styleUrls: ['./contractors-liability.component.scss']
})
export class ContractorsLiabilityComponent implements OnInit {
  summaryPanel;
  get summaryAPIData() {
    return this.summaryPanel;
  }
  @Input() set summaryAPIData(value) {
    this.summaryPanel = { ...value };
  }
  @Input() summarySitecoreData;
  @Input() pageName;

  constructor() {}

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }
}
